"use client";
import o from "styled-components";
import "react";
import "./index.es9.js";
import "./index.es10.js";
import "./index.es11.js";
import "./index.es12.js";
import "./index.es13.js";
import "./index.es14.js";
import "./index.es15.js";
import "./index.es16.js";
import "./index.es17.js";
import t from "./index.es62.js";
import "./index.es27.js";
import "./index.es28.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import "./index.es23.js";
import "./index.es24.js";
import "./index.es25.js";
import "./index.es26.js";
import "./index.es29.js";
import "./index.es30.js";
import "./index.es31.js";
import "./index.es32.js";
const r = "stat-monitor-group-keys", M = o.div`
  .${r} {
    background: #fff;
  }

  ${t.mediaQueries["bl-handset-large-up"]} {
    display: flex;
    justify-content: space-between;
  }
`;
export {
  M as default,
  r as spreadKeysClass
};
//# sourceMappingURL=index.es79.js.map
